/**
 * The value, or the TypeError the untyped code threw when it read a property of a missing value
 * (e.g. destructuring `data` of a mutation result, or a cache entry `readQuery` did not find).
 * Apollo Client 4 resolves a mutation with data unless it failed, so these throws are the crash
 * paths of the former code kept as they were.
 */
const requireValue = <T>(value: T | null | undefined, property: string): T => {
  if (value === null || value === undefined) {
    throw new TypeError(`Cannot read properties of ${String(value)} (reading '${property}')`);
  }
  return value;
};

export default requireValue;
